// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"f3041bfc","229":"84553cab","290":"4870d4ed","381":"e145c989","842":"38891a37","851":"dd512299","924":"1fbfae75","974":"491d54c6"}[chunkId] + ".chunk.js";
};